// @ts-check

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import SimpleTextInput from '../common/SimpleTextInput'
import Box from '@material-ui/core/Box';
import Accordion from '../../custom/Accordion';
import AccordionSummary from '../../custom/AccordionSummary';
import AccordionDetails from '../../custom/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import useFormStyles from '../../common/FormStyle';
import {
  SET_COSTS
} from '../../../redux/actions/actionTypes'

function PreConstruction(props) {
  const formStyles = useFormStyles();
  const dispatch = useDispatch()
  const costsState = useSelector(state => state.globalFormData.costs);

  const [expanded, setExpanded] = useState(false);
  const handleExpanded = () => {
    setExpanded(!expanded);
  };
  return (
    <Accordion expanded={expanded} onChange={handleExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon fontSize="small" />}
        aria-controls="plotInfo-content"
        id="plotInfo-header"
        IconButtonProps={{
          className: formStyles.expandButton
        }}
      >
        <Typography className={clsx(formStyles.accordionSubheader, formStyles.bold)}>Pre-construction</Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Box className={formStyles.w100}>
          <SimpleTextInput label="Demolition" name="demolition" type="number"
            value={costsState.demolition}
            numberFormated={true}
            onChange={(event) => {
              dispatch({
                type: SET_COSTS,
                payload: {
                  field: 'demolition',
                  value: event.target.value
                }
              })
            }}
          />

          <SimpleTextInput label="Site preparation" name="site_preparation" type="number"
            value={costsState.site_preparation}
            numberFormated={true}
            onChange={(event) => {
              dispatch({
                type: SET_COSTS,
                payload: {
                  field: 'site_preparation',
                  value: event.target.value
                }
              })
            }}
          />

          <SimpleTextInput label="Infrastructure" name="infrastructure" type="number"
            value={costsState.infrastructure}
            numberFormated={true}
            onChange={(event) => {
              dispatch({
                type: SET_COSTS,
                payload: {
                  field: 'infrastructure',
                  value: event.target.value
                }
              })
            }}
          />

          <SimpleTextInput label="Excavation" name="excavation" type="number"
            value={costsState.excavation}
            numberFormated={true}
            onChange={(event) => {
              dispatch({
                type: SET_COSTS,
                payload: {
                  field: 'excavation',
                  value: event.target.value
                }
              })
            }}
          />

          <SimpleTextInput label="Other" name="pre_construction_other" type="number"
            value={costsState.pre_construction_other}
            numberFormated={true}
            onChange={(event) => {
              dispatch({
                type: SET_COSTS,
                payload: {
                  field: 'pre_construction_other',
                  value: event.target.value
                }
              })
            }}
          />

        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default PreConstruction